import React, { FC } from 'react';
import { ApplicationWarnings } from 'omni-package-react-core';
import { Helmet } from 'react-helmet';
import { injectTranslations } from 'ia-react-core';
import { useTranslation } from 'react-i18next';
import { StyledTitle, StyledInstabilityMessages } from '../LoginPage/LoginPage.styles';
import SignIn from './SignIn';
import LangueFr from './translations/fr';
import LangueEn from './translations/en';
import InformativeMessage from '../../components/InformativeMessage';
export interface LoginPageProps {
  mobileDeviceMode: Boolean;
  showInstabilityMessages?: boolean;
  showUnavailabilityWarning?: boolean;
  titleCustomEn: string;
  titleCustomFr: string;
  disableSignUp?: boolean;
  showRememberMe?: boolean;
  hidePageTitle?: boolean;
}
const LoginPageV2: FC<LoginPageProps> = ({ titleCustomEn, titleCustomFr, mobileDeviceMode, showInstabilityMessages = true, showUnavailabilityWarning = false, disableSignUp = false, showRememberMe = false, hidePageTitle = false }) => {
  const needReInject = titleCustomEn || titleCustomFr;
  if (titleCustomEn) {
    LangueEn.widgetTitleConnexion = titleCustomEn;
  }
  if (titleCustomFr) {
    LangueFr.widgetTitleConnexion = titleCustomFr;
  }
  if (needReInject) {
    injectTranslations('LoginPageV2', [
      { language: 'fr', resource: LangueFr },
      { language: 'en', resource: LangueEn },
    ]);
  }
  const { t } = useTranslation('LoginPageV2');
  return (
    <>
      <Helmet><title>{t('widgetTitleConnexion')}</title></Helmet>
      <div>
        <StyledInstabilityMessages id="StyledInstabilityMessagesID">
          <ApplicationWarnings showInstabilityMessages={showInstabilityMessages} showUnavailabilityWarning={showUnavailabilityWarning} />
        </StyledInstabilityMessages>
        {!mobileDeviceMode && !hidePageTitle ? <StyledTitle id="StyledTitleId">{t('widgetTitleConnexion')}</StyledTitle> : null}
        <InformativeMessage mobileDeviceMode={mobileDeviceMode} />
        <SignIn mobileDeviceMode={mobileDeviceMode} title={t('widgetTitleConnexion')} StyledInstabilityMessagesID="StyledInstabilityMessagesID" StyledInformativeMessageID="StyledInformativeMessageID" StyledTitleId="StyledTitleId" disableSignUp={disableSignUp} showRememberMe={showRememberMe ?? false} />
      </div>
    </>
  );
};

export default LoginPageV2;
